export enum PingWeightEnum {
  NO_SIGNAL = 'nosignal',
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

export interface PingView {
  timestamp: Date;
  pingWeight: PingWeightEnum;
}
